import { useConfig } from "../../hooks/useConfig";
import { LAUNCH_FEE } from "../../lib/facts";
import { creatorShare, platformFee, tradersPay } from "../../lib/fees";

export function WhatItIs() {
  const { config } = useConfig();

  return (
    <section className="shell section section--ruled" id="what-it-is">
      <div className="split">
        <div className="stack stack-3">
          <p className="eyebrow">What $TISM is</p>
          <h2>A memecoin with one job.</h2>
        </div>
        <div className="stack stack-4">
          <p className="body">
            $TISM is a token. It does not do anything else. There is no product behind it, no
            roadmap, and no revenue. It exists to put autism acceptance in front of people who trade
            memecoins, and to send money to a charity that works with Autistic people in Vancouver.
          </p>
          <p className="body">
            The launch runs on the Pons v2 launchpad on Robinhood Chain, chain id 4663. Creating the
            token costs {LAUNCH_FEE}. Every trade after that pays a platform fee of{" "}
            {platformFee(config)} plus a creator tax the creator set once at launch, which goes to
            the creator wallet. The total traders pay is {tradersPay(config)}, and the creator's
            share is {creatorShare(config)}.
          </p>
          <p className="body">
            Once the launch is live there is no mint, no freeze, no blacklist, and no way to change
            the fee. Nobody, the team included, can turn any of that back on.
          </p>
          <p className="tiny">
            The launch fee and the platform fee were read from the Pons v2 create form on
            2026-09-04. The creator tax is set on that same form at launch, and this page reads it
            from the server. Check the listing yourself before you trade.
          </p>
        </div>
      </div>
    </section>
  );
}
